module.exports = "/images/drinks.jpg";